import React from "react";
import CaretRight from "../../../../assets/svg/icons/common/CaretRight";
import AlertDot from "../../../../components/AlertDot/AlertDot";
import StatusDot from "../../../../components/StatusDot/StatusDot";
import styles from "../../Style.module.scss";

const PROCESSING_COLOR = "#37B450";
const NOT_PROCESSING_COLOR = "#BFBFC3";

function MerchantCard({ app, onClick, isSelected }) {
  const hasChildren = app?.children && app.children.length > 0;

  return (
    <div
      className={`${styles.mobile_card} ${isSelected ? styles.selected : ""}`}
      onClick={onClick}
    >
      {app?.merchant_details?.alert && (
        <div className={styles.mobile_card_alert}>
          <AlertDot />
        </div>
      )}
      <div className={styles.mobile_card_left}>
        {hasChildren && (
          <div className={styles.mobile_card_caret}>
            <CaretRight />
          </div>
        )}
      </div>
      <div className={styles.mobile_card_center}>
        <div className={styles.mobile_card_name}>{app.field_dba}</div>
      </div>
      <div className={styles.mobile_card_right}>
        {app?.merchant_details?.status == "O" ? (
          <StatusDot color={PROCESSING_COLOR} />
        ) : (
          <StatusDot color={NOT_PROCESSING_COLOR} />
        )}
      </div>
    </div>
  );
}

export default MerchantCard;
